// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bib_wx bib_jb bib_xl bib_i bib_j bib_q bib_vt bib_et bib_so bib_sp bib_eg","CommentsButton__icon":"il_b bib_rz"};